import React from 'react';
import c from 'classnames';

import {
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphImage = ({ entity }) => {
  let image = entity.getIn(['field_image', 0, 'styles', 'image_paragraph']);
  const imageType = entity.getIn(['field_image_type', 0, 'value']);

  const IMAGE_TYPE_DEFAULT = 'default';
  const IMAGE_TYPE_BIG = 'big';
  const IMAGE_TYPE_ORIGINAL_RATIO = 'original';

  switch (imageType) {
    case IMAGE_TYPE_BIG: {
      image = entity.getIn(['field_image', 0, 'styles', 'image_paragraph_big']);
      break;
    }

    case IMAGE_TYPE_ORIGINAL_RATIO: {
      image = entity.getIn(['field_image', 0, 'styles', 'image_paragraph_original_ratio']);
      break;
    }

    case IMAGE_TYPE_DEFAULT:
    default: {
      image = entity.getIn(['field_image', 0, 'styles', 'image_paragraph']);
      break;
    }
  }

  const ParagraphImageInnerClasses = c('ParagraphImage__inner col-12', {
    'col-md-10 col-lg-8 offset-md-1 offset-lg-2': imageType === IMAGE_TYPE_DEFAULT || imageType === IMAGE_TYPE_ORIGINAL_RATIO,
    'col-md-12 col-lg-12': imageType === IMAGE_TYPE_BIG,
  });

  return (
    <Container className="ParagraphImage">
      <div className="row">
        <div className={ParagraphImageInnerClasses}>
          <Image
            className="ParagraphImage__image"
            lazyload={false}
            src={image}
          />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphImage;
